import type { Styles } from '@adornis/ass/style.js';
import { setGlobalStyle } from '@adornis/chemistry/elements/theming/global-style.js';
import { addFontData, fontReset } from '@adornis/fonts/font-resets.js';
import { XH1, XH2, XH3, XH4, XText } from '@adornis/fonts/fonts.js';
import { customElement } from 'lit/decorators.js';

setGlobalStyle(() => ({
  'main-element ::selection, :host ::selection': { color: 'white', background: '#00628F' }, // TODO use design system to determin color

  // ! dont set body styles if using this in standalone components, this will manipulate the fonts of the embedding page
  'main-element, :host': { fontFamily: 'Albert Sans', fontSize: `${1.0625 * 16}px`, lineHeight: '1.4' }, // default font for whole page
}));

addFontData('Albert Sans', {
  capHeightRatio: 0.9 - 0.118,
  descenderHeightRatio: 0.118,
  700: {
    capHeightRatio: 0.84 - 0.178,
    descenderHeightRatio: 0.178,
  },
});

@customElement('tr-text')
export class TrText extends XText {
  override styles() {
    return [
      fontReset('Albert Sans', 1, 500, 1.214, this.baseFontSize),
      {
        input: {
          color: 'inherit',
        },
        '&[bold]': { fontWeight: 'bold' },
        '&[italic]': { fontStyle: 'italic' },
        '&[pointer]': { cursor: 'pointer' },
        '&[align-end]': { textAlign: 'end' },
        '&[tone=subtle]': { color: this.colors.tone.subtle },
        '&[tone=success]': { color: this.colors.tone.success },
        '&[tone=warning]': { color: this.colors.tone.warning },
        '&[tone=error]': { color: this.colors.tone.error },
        '&[tone=onyx]': { color: this.colors.tone.onyx },
        '&[tone=accent]': { color: this.colors.accent },
        '&[tone=placeholder]': { color: this.colors.tone.placeholder },
        '&[small]': {
          fontSize: '12px',
        },
        '&[center]': {
          textAlign: 'center',
        },
      },
    ] as Styles[];
  }
}

@customElement('tr-h1')
export class TrH1 extends XH1 {
  override styles() {
    return [
      fontReset('Albert Sans', 1.5, 400, 2.2, 22),
      {
        letterSpacing: '-2px',
        '&[bold]': { fontWeight: 'bold' },
      },
      {
        '@media screen and (min-width: 21.5625em)': {
          fontSize: '2.25rem',
        },

        '@media screen and (min-width: 40em)': {
          fontSize: '2.5rem',
        },
        '@media screen and (min-width: 64em)': {
          fontSize: '2.5rem',
        },
        '@media screen and (min-width: 75em)': {
          fontSize: '3.5rem',
        },
      },
    ] as Styles[];
  }
}

@customElement('tr-h2')
export class TrH2 extends XH2 {
  override styles() {
    console.log(`====> ${this.baseFontSize}`);
    return [
      fontReset('Albert Sans', 1.5, 700, 0.5, this.baseFontSize),
      {
        fontSize: '32px',
        lineHeight: '36px',
        letterSpacing: '-1px',
        '&[bold]': { fontWeight: 'bold' },
        '&[page-title]': { marginBottom: '0.5em' },
      },
    ] as Styles[];
  }
}

@customElement('tr-h3')
export class TrH3 extends XH3 {
  override styles() {
    return [
      fontReset('Albert Sans', 1, 400, 1.16, this.baseFontSize),
      {
        fontSize: '24px',
        lineHeight: '30px',
        letterSpacing: '-1px',
        '&[align-end]': { textAlign: 'end' },
        '&[tone=subtle]': { color: this.colors.tone.subtle },
        '&[tone=success]': { color: this.colors.tone.success },
        '&[tone=warning]': { color: this.colors.tone.warning },
        '&[tone=error]': { color: this.colors.tone.error },
        '&[highlight]': { color: this.colors.accent },
        '&[bold]': { fontWeight: 'bold' },
      },
    ] as Styles[];
  }
}

@customElement('tr-h4')
export class TrH4 extends XH4 {
  override styles() {
    return [
      ...super.styles(),
      fontReset('Albert Sans', 1, 400, 1.2, this.baseFontSize),
      {
        '&[highlight]': { color: this.colors.accent },
        '&[bold]': { fontWeight: 'bold' },
        '&[center]': {
          textAlign: 'center',
        },
      },
    ] as Styles[];
  }
}
